export const BACKEND_URL: string = 'https://staffelbach.synapto.ch/api';
